import { passThroughAxios } from './passThrough.axios'

const BASE = 'lease-mapping'

export default {
  getAllLeaseMappings() {
    return passThroughAxios.get(BASE)
  },
  createLeaseMapping(payload) {
    return passThroughAxios.post(BASE, payload)
  },
  deleteLeaseMapping(debtorId, dealerId) {
    return passThroughAxios.delete(`${BASE}/${encodeURIComponent(debtorId)}`, {
      params: { rowDealerId: dealerId },
    })
  },
}
